<div *ngIf="showErrorMsg">
  <h1 class="harp-card-title">Challenge Question</h1>
  <p>
    Please answer your challenge question to edit your two-factor authentication
    devices
  </p>
  <p>
    All fields marked with an asterisk (<span class="required">*</span>) are
    required.
  </p>

  <app-challenge-question-form
    (verifyAnswerSuccess)="onVerifyRecoveryAnswerSuccess($event)"
    (verifyAnswerError)="onVerifyRecoveryAnswerError($event)"
    (isValidRecoveryToken)="onIsValidRecoveryToken($event)"
    service="factorRecoveryService"
  ></app-challenge-question-form>
</div>

<!-- Invalid Recovery Token Error Message -->
<div *ngIf="!showErrorMsg">
  <h1 class="harp-card-title">Error!</h1>
  <p>{{ errorMessage }}</p>
  <a [routerLink]="['/login']" queryParamsHandling="merge"
    ><strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
  >
</div>
